import React, { Component } from "react";
// import { movies } from "../moviesData";
import axios from "axios";

export class Movieslist extends Component {
  constructor() {
    super();
    this.state = {
      hover: "",
      parr: [1],
      moviesData: [],
      currPage: 1,
      favourites: []
    };
  }

  async componentDidMount() {
    const res = await axios.get(
      `https://api.themoviedb.org/3/movie/popular?api_key=a4e872cfa9bf14981619dad0be6885a1&language=en-US&page=1`
    );
    let movieData = res.data;
    this.setState({
      moviesData: [...movieData.results]
    });
  }

  handleFavourites = (movie) => {
    let oldData = JSON.parse(localStorage.getItem("movies") || "[]");
    if (this.state.favourites.includes(movie.id)) {
      oldData = oldData.filter((movieobj) => movie.id != movieobj.id);
    } else {
      oldData.push(movie);
    }
    localStorage.setItem("movies", JSON.stringify(oldData));

    this.setFavouritesState();
  };

  setFavouritesState = () => {
    let oldData = JSON.parse(localStorage.getItem("movies") || "[]");
    let tempArr = oldData.map((movie) => movie.id);
    this.setState({
      favourites: [...tempArr]
    });
  };

  handleMoviesPage = async () => {
    const res = await axios.get(
      `https://api.themoviedb.org/3/movie/popular?api_key=a4e872cfa9bf14981619dad0be6885a1&language=en-US&page=${this.state.currPage}`
    );
    let movieData = res.data;
    this.setState({
      moviesData: [...movieData.results]
    });
  };

  handleNext = () => {
    //console.log("handleNext");
    let tempArr = [];

    for (let i = 1; i <= this.state.parr.length + 1; i++) {
      tempArr.push(i);
    }
    this.setState(
      {
        parr: [...tempArr],
        currPage: this.state.currPage + 1
      },
      this.handleMoviesPage
    );

    //If we want to call just after setState() method
    //we can pass in setState itself
  };

  handlePrevious = () => {
    console.log("handlePrevious");

    if (this.state.currPage != 1) {
      this.setState(
        {
          currPage: this.state.currPage - 1
        },
        this.handleMoviesPage
      );
    }
    //If we want to call just after setState() method
    //we can pass in setState itself
  };

  handlePageClick = (value) => {
    if (value !== this.state.currPage) {
      this.setState(
        {
          currPage: value
        },
        this.handleMoviesPage
      );
    }
  };

  render() {
    return (
      <>
        <center>
          <strong>Trending</strong>
        </center>

        <div className="movie-list">
          {this.state.moviesData.map((movieobj) => (
            <div
              className="card movie-card"
              onMouseEnter={() => this.setState({ hover: movieobj.id })}
              onMouseLeave={() => this.setState({ hover: "" })}
            >
              <img
                className="movielist-img"
                src={`https://image.tmdb.org/t/p/original${movieobj.backdrop_path}`}
                alt=""
              />
              {this.state.hover == movieobj.id && (
                <div className="button-wrapper">
                  <button
                    type="button"
                    className="btn btn-primary movielist-btn"
                    onClick={() => this.handleFavourites(movieobj)}
                  >
                    {this.state.favourites.includes(movieobj.id)
                      ? "Remove from Favourites"
                      : "Add to Favourites"}
                  </button>
                </div>
              )}
              <h5 className="card-title movielist-title">{movieobj.title}</h5>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <nav aria-label="Page navigation example ">
            <ul className="pagination">
              <li className="page-item">
                <a className="page-link" onClick={this.handlePrevious}>
                  Previous
                </a>
              </li>
              {this.state.parr.map((value) => (
                <li className="page-item">
                  <a
                    className="page-link"
                    onClick={() => this.handlePageClick(value)}
                  >
                    {value}
                  </a>
                </li>
              ))}
              <li className="page-item">
                <a className="page-link" onClick={this.handleNext}>
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </>
    );
  }
}

export default Movieslist;
